export default "__VITE_ASSET__923ae774__"